import { useMemo } from "react";

import { CloudflowEngineModel, type CloudflowExecutionModel } from "@doitintl/cmp-models";
import { getCollection, type WithModel } from "@doitintl/models-any";
import { useDocumentData } from "@doitintl/models-hooks";

export function useExecutionModel(executionId: string): {
  execution: WithModel<CloudflowExecutionModel> | undefined;
  loading: boolean;
  error: Error | undefined;
} {
  const query = useMemo(
    () => getCollection(CloudflowEngineModel).doc("cloudflows").collection("cloudflowExecutions").doc(executionId),
    [executionId]
  );

  const [execution, loading, error] = useDocumentData(query);

  return { execution, loading, error };
}
